var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBrandPanelWave = props => /*#__PURE__*/React.createElement("svg", _extends({
  height: 200,
  fill: "none",
  preserveAspectRatio: "none",
  viewBox: "0 0 600 200"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--color-white-overlay-30, rgba(255, 255, 255, 0.3))",
  d: "M0 80c100-40 200 40 300 0s200 40 300 0v120H0Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--color-white-overlay-20, rgba(255, 255, 255, 0.2))",
  d: "M0 120c100-40 200 40 300 0s200 40 300 0v80H0Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--color-white-overlay-10, rgba(255, 255, 255, 0.1))",
  d: "M0 150c100-30 200 30 300 0s200 30 300 0v50H0Z"
})));
export default SvgBrandPanelWave;